import Hero from '../components/Hero';
import AboutPreview from '../components/AboutPreview';
import WhoWeAre from '../components/WhoWeAre';
import VisionMission from '../components/VisionMission';
import WhyChooseUs from '../components/WhyChooseUs';

export default function Home() {
  return (
    <>
      <Hero />
      <AboutPreview />
      <WhoWeAre />
      <VisionMission />
      <WhyChooseUs />
    </>
  );
}
